module.exports = __webpack_public_path__ + "img/icon-titulo.6af710ad.jpg";